module.exports = __webpack_public_path__ + "img/Email.159df0ed.svg";